export default function NoresultImage({ handleNoRecords }) {
    return (
        <>
            <div className="container-fluid" >
                <div className="upload_imege_div">
                    <div className="uploadimage_div" onClick={() => handleNoRecords()}>
                        {/* <input type="file" /> */}
                        <img src="/assets/images/noresult.svg" alt="" />
                    </div>
                    <h5>No Results Found</h5>
                    <p>Try uploading a clear image or scan your face again. <br />Your image will be available here if you have met the PM after 13th July 2022.</p>
                    <h6 className="email_color">For any issues please send an email to <a href="mailto:support@narendramodi.in">support@narendramodi.in</a></h6>
                </div>
            </div>
        </>
    )
}